export enum ResponseErrorCodes {
  FLIGHT_ROOM_PENDING_JOIN = 'FlightRoomPendingJoin',
  INSUFFICIENT_PERMISSIONS = 'INSUFFICIENT_PERMISSIONS',
  UNAUTHORIZED = 'Unauthorized',
  USER_INACTIVE = 'USER_INACTIVE',
}
